<template>
    <div>
        <div class="modal fade" :class="{'is-open': open}">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="$emit('close')"><i class="icon-close"></i></button>
                        <h3 class="modal-title">離退職人員名單</h3>
                    </div>
                    <div class="modal-body">
                        <section class="search pb-0 mb-4">
                            <div class="row">
                                <div class="col-12">
                                    <form class="form">
                                        <div class="input-group input-lg">
                                            <div class="input">
                                                <input
                                                    type="text"
                                                    name="keyowrd"
                                                    id="keyowrd"
                                                    class="form-control"
                                                    v-model="keyowrd"
                                                    placeholder="輸入服務人員姓名或收費代號進行搜尋..."
                                                />
                                            </div>
                                            <button
                                                class="btn btn-primary btn-icon"
                                                type="button"
                                                @click.prevent="doSearch()"
                                            >
                                                <i class="icon-search i-24"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                        <table class="segment-table table datatable table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th width="60px"></th>
                                    <th width="130px">離退職人員</th>
                                    <th width="130px">離退職人員<br>收費代號</th>
                                    <th width="110px">增員者</th>
                                    <th width="100px">增員者<br>收費代號</th>
                                    <th>備註</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(resign, key) in searchResult" :key="`td-${key}`">
                                    <td width="60px">
                                        <div class="mr-0 radio-inline">
                                            <input
                                                v-model="selection"
                                                type="radio"
                                                :id="`check-${key}`"
                                                :value="resign"
                                                @change="$emit('update', selection)"
                                            >
                                            <label :for="`check-${key}`"></label>
                                        </div>
                                    </td>
                                    <td width="130px">{{ resign.resign_name }}</td>
                                    <td width="130px">{{ resign.resign_ceclcno }}</td>
                                    <td width="110px">{{ resign.intr_name }}</td>
                                    <td width="100px">{{ resign.intr_ceclcno }}</td>
                                    <td>{{ resign.intr_ceclcno ? "2023/13工後入職" : "" }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button type="button" @click="$emit('close')" class="btn btn-default">取消</button>
                                <button type="button" @click="doOpenConfirmModal" class="btn btn-primary">選擇</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <unlock-resign-modal
          :confirmModalOpen="confirmModalOpen"
          :resignInfo="selection"
          page="manger"
          @close="panelClose('confirmModalOpen')"
          @close-all="doCloseConfirm"
        />
    </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { getResignIntrList, doQueryResignUnlock } from "@/service";
import UnlockResignModal from "@/desktop/components/manager/UnlockResignModal";
export default {
  name: "ResignModal",
  mixins: [commonMixin],
  components: { UnlockResignModal },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    cedvno3: {
      type: String,
      require: true
    }
  },
  watch: {
    /**
     * 查詢離退人員(2023/13工後入職者)對應增員者名單
     * @param {Boolean} val 是否開啟
     */
    open: function(val) {
      if (val && this.cedvno3) {
        this.queryResignList();
      }
    }
  },
  data() {
    return {
      keyowrd: "",
      selection: {},
      resignList: [],
      searchResult: [],
      confirmModalOpen: false,
      memoType: "",
      unlockOption: [
        {
          label: "單位服務件資源",
          value: "1"
        },
        {
          label: "分配需求",
          value: "2"
        },
        {
          label: "自行輸入原因",
          value: "9"
        }
      ],
      memo: ""
    };
  },
  methods: {
    /** 搜尋服務人員姓名或收費代號 */
    doSearch: function() {
      this.selection = {};
      this.searchResult = this.resignList.filter(e => {
        return (
          e.resign_ceclcno.includes(this.keyowrd) ||
          e.resign_name.includes(this.keyowrd) ||
          e.intr_name.includes(this.keyowrd) ||
          e.intr_ceclcno.includes(this.keyowrd)
        );
      });
      this.searchResult = this.searchResult.sort((a, b) => {
        if (!a.intr_ceclcno) {
          return 1;
        }

        if (!b.intr_ceclcno) {
          return -1;
        }

        return a.intr_ceclcno < b.intr_ceclcno ? -1 : 1;
      });
      this.registerHanlink();
    },
    /** 查詢離退人員(2023/13工後入職者)對應增員者名單 */
    queryResignList: function() {
      this.selection = {};
      this.keyowrd = "";
      this.resignList = [];
      getResignIntrList(this.$store.state.userInfo.id, this.cedvno3).then(
        result => {
          if (result && result.header.status == "200" && result.body) {
            this.resignList = result.body.resign_list || [];

            if (this.resignList.length > 0) {
              this.resignList.forEach(e => {
                if (!Object.prototype.hasOwnProperty.call(e, "intr_ceclcno")) {
                  e.intr_ceclcno = "";
                }

                if (!Object.prototype.hasOwnProperty.call(e, "intr_id")) {
                  e.intr_id = "";
                }

                if (!Object.prototype.hasOwnProperty.call(e, "intr_name")) {
                  e.intr_name = "";
                }
              });
            }

            this.searchResult = [...this.resignList];
            this.searchResult = this.searchResult.sort((a, b) => {
              if (!a.intr_ceclcno) {
                return 1;
              }

              if (!b.intr_ceclcno) {
                return -1;
              }

              return a.intr_ceclcno < b.intr_ceclcno ? -1 : 1;
            });
          }
        }
      );

      this.registerHanlink(); // 難字 update
    },
    /** 關閉視窗 */
    doCloseConfirm: function() {
      this.panelClose("confirmModalOpen");
      this.$emit("close-all");
    },
    /** 開啟確認視窗 */
    doOpenConfirmModal: function() {
      if (!this.selection.resign_id) {
        this.$toast.info({ title: "請選擇離退職人員" });
        return;
      }
      if (this.selection.intr_id) {
        doQueryResignUnlock(
          this.$store.state.userInfo.id,
          this.selection.resign_id,
          this.selection.intr_id
        ).then((result) => {
          if (result && result.header.status == "200" && result.body) {
            if (result.body.is_unlock === "N") {
              this.panelOpen("confirmModalOpen");
            } else {
              this.$store.dispatch("updateIsResignType", true);
              this.$store.dispatch("updateIsQryResginUnlock", true);
              this.selection.is_unlock = "Y"
              this.$store.dispatch("updateResignInfo", this.selection);
              this.$emit("close-all");
            }
          }
        });
      } else {
        this.$store.dispatch("updateIsResignType", true);
        this.selection.is_unlock = ""
        this.$store.dispatch("updateResignInfo", this.selection);
        this.$emit("close-all");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.segment-table thead tr,
.segment-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.segment-table tbody tr {
  height: 54px;
}

.segment-table tbody {
  display: block;
  height: 300px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
